import { Body, LayoutGrid, Section } from '@innovationnorway/component-library';
import { ReactNode, useContext } from 'react';
import { FormLayoutRedesignEnabled } from '../../constants/featureFlags';
import { AppContext } from '../../context/app-context';
import { LayoutContext } from './LayoutContext';

type ConditionalRendererProps = {
  children: ReactNode;
  leftContent?: ReactNode;
};

const DefaultLayout = ({ children }: { children: ReactNode }) => (
  <Body id="main-content">
    <Section>
      <LayoutGrid className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-8 lg:grid-cols-12">
        <div className="w-full col-span-4 mx-auto sm:col-span-4 md:col-span-8 lg:col-span-12">{children}</div>
      </LayoutGrid>
    </Section>
  </Body>
);

export const ConditionalRender = ({ children, leftContent }: ConditionalRendererProps) => {
  const context = useContext(LayoutContext);
  const { state } = useContext(AppContext);

  const features = state.configuration.features;
  const feature = features.find((f) => f.name === FormLayoutRedesignEnabled);

  if (!context) {
    console.warn('ConditionalRenderer must be used within a LayoutProvider');
    return <DefaultLayout>{children}</DefaultLayout>;
  }

  const { layout } = context;

  if (layout === 'form' && feature?.isActive) {
    return (
      <div className="relative">
        {leftContent && <aside className="hidden lg:block absolute inset-y-0 left-0 w-64 p-4 bg-gray-100">{leftContent}</aside>}

        <div className="mx-auto w-full max-w-screen-xl px-4 sm:px-6 lg:px-8">
          <main className={`p-4 md:p-10 ${leftContent ? 'lg:pl-64' : ''}`} id="main-content">
            {children}
          </main>
        </div>
      </div>
    );
  }

  return <DefaultLayout>{children}</DefaultLayout>;
};
